import type { ReturnRequest } from "../types";

type CancellableReturnRequest = {
  status: { cancelled: Pick<ReturnRequest["status"]["cancelled"], "done"> };
};

type OpenReturnContext = {
  uniqueReturnOnly: boolean;
  isMerchant: boolean;
  returnRequests: CancellableReturnRequest[];
};

// Same rule as the creation guard (`CreateReturnRequestService`, preference
// `allowOnlyUniqueReturnRequest`): once the shop allows a single return per
// order, every return that is not cancelled closes the order to a new one, a
// rejected return included. A member of the shop keeps the right to open
// another.
export function canOpenReturn({
  uniqueReturnOnly,
  isMerchant,
  returnRequests,
}: OpenReturnContext): boolean {
  if (!uniqueReturnOnly || isMerchant) return true;

  return returnRequests.every((rr) => rr.status.cancelled.done);
}
